import { Select as SelectAnt } from 'antd';
import 'antd/lib/select/style';

export default SelectAnt.Option;
